import React, { useContext } from "react";
import { FilterContext } from "./filters-context";
const FiltersVisibility = () => {
  const { filters, toggleFilters } = useContext(FilterContext);
  const onFiltersVisibilityClick = () => {
    toggleFilters(!filters.visibility);
  };
  return (
    <button
      className="filters-visibility"
      onClick={() => {
        onFiltersVisibilityClick();
      }}
    >
      Filtrer {`${filters.visibility ? "-" : "+"}`}
    </button>
  );
};

export default FiltersVisibility;
